import { Component, Vue } from 'vue-property-decorator';
import vueCustomScrollbar from 'vue-custom-scrollbar';
import RefCardItem from '@/shared/cards/briefing/ref-card-item/ref-card-item.vue';

let dropboxAccessToken: string | null = null;

@Component({
  components: {
    'ref-item': RefCardItem,
    vueCustomScrollbar: vueCustomScrollbar,
  },
})
export default class DropBoxSigninComponent extends Vue {
  openDropboxPopup() {
    const clientId = 't02vzfz7zqrloum'; // Thay bằng Dropbox App Key của bạn
    const authUrl = `https://www.dropbox.com/oauth2/authorize?client_id=${clientId}&response_type=token`;

    const popup = window.open(authUrl, '_blank', 'width=500,height=600');

    const interval = setInterval(() => {
      if (!popup || popup.closed) {
        clearInterval(interval);
        return;
      }

      try {
        if (popup.location.href.includes('api/public/goAuth')) {
          const params = new URLSearchParams(popup.location.search);
          const code = params.get('code');
          console.log('Mã code nhận được:', code);
        }
      } catch (error) {
        console.log('chưa redirect về cùng origin');
      }
      const hashParams = new URLSearchParams(popup.location.hash.substring(1));
      const token = hashParams.get('access_token');

      if (token) {
        dropboxAccessToken = token;
        console.log('Dropbox Token:', dropboxAccessToken);
        popup.close();
        this.fetchAndEmitDropboxUserInfo(dropboxAccessToken);
        clearInterval(interval);
      }
    }, 1000);
  }

  async fetchAndEmitDropboxUserInfo(token: string) {
    try {
      const response = await fetch('https://api.dropboxapi.com/2/users/get_current_account', {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
      });
      const userInfo = await response.json();
      console.log('Dropbox User Info:', userInfo);
      this.$emit('dropbox-token', token, userInfo);
    } catch (error) {
      console.error('Error fetching Dropbox user info:', error);
    }
  }
}
